<!--
@name 硕士教育-MBA（精益管理方向）
-->
<template>
  <div class="cont-page">
    <!-- 公共导航 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <!-- 内容 -->
    <div class="content">
      <!--  专业介绍 -->
      <div class="cont-item">
        <div class="title-image">专业介绍</div>
        <div class="selector-indent">
          工商管理硕士（精益管理方向）立足中国本土，汇聚中欧经管领域资深专家、行业领袖、精益顾问等，打造独具特色的培养体系，从宏观到微观，从理论到实践，构建全面系统的企业经营知识框架，着力培养具有广泛的管理知识与精益思维、开阔的视野与格局、卓越的运营与精益领导力、高度社会责任感的优秀企业管理人才。
        </div>
        <div class="selector-indent">
          工商管理硕士专业的课程不仅涵盖了传统各个商业领域，如宏观经济、组织行为、战略管理等，还包括有培养精益理念、成本管理、精益PMC等方向的课程。
        </div>
      </div>
      <!--  专业介绍 -->
      <!--  项目优势 -->
      <div class="cont-item">
        <div class="title-image">项目优势</div>
        <div class="advantage">
          <p class="advantage-title">卓越资质</p>
          <p>AACSB认证的全球顶尖精英商校，中国教育部涉外信息监管网可查。</p>
          <p class="advantage-title">正规保障</p>
          <p>免考试，面试审核制入学，校本部直招，法国校本部学籍注册，中国国内在职研读。</p>
          <p class="advantage-title">课程严谨</p>
          <p>遵循国际商学院协会(AACSB) 标准设置课程，引入国际先进管理理念教材，依托经典案例分析，深化知识体系。</p>
          <p class="advantage-title">实战体系</p>
          <p>
            立足本土实用导向的课程设计，“课堂讲授+案例分析+共创工作坊+沉浸式研学”多种形式相结合，提升理论应用、分析和解决实际管理问题的能力。</p>
          <p class="advantage-title">中外联合</p>
          <p>国内一流大学师资及业内专家强强联合，法国高校教授鼎力加特。</p>
          <p class="advantage-title"> 广阔平台</p>
          <p>庞大的校友网络、专家智库、政府与金融机构链接等，搭建高端商务交流、资源整合的优质平台。</p>
        </div>
      </div>
      <!-- 项目优势 -->
      <!-- 培养方式 -->
      <div class="cont-item">
        <div class="title-image">培养方式</div>
        <div class="selector-indent">
          法国布雷斯特高等商学院MBA专业采用线上教学加线下实践、自主学习和毕业论文相结合的方式进行为期18个月的学习。毕业季时组织学生集体去法国参加研修及毕业典礼。
        </div>
      </div>
      <!-- 培养方式 -->
      <!-- 课程简介 -->
      <div class="cont-item">
        <div class="title-image">培养方式</div>
        <p>工商管理硕士学制18个月，共计20门课程，19门必修课，1门语言课，修满60学分进入论文答辩阶段。</p>
        <img src="../assets/images/personRain/mba-lean-course.png" alt="" class="course-img"/>
      </div>
      <!-- 课程简介 -->
      <!-- 部分师资 -->
      <div class="cont-item">
        <div class="title-image">部分师资</div>
        <p>Luc Pontet：布雷斯特高等商学院副校长，（Chambre de Commerce et d’Industrie de Brest）信息技术及培训负责人。</p>
        <p>Mériadec Le
          Mouillour：海事功勋骑士勋章获得者，前西布列塔尼工商会总经理，法国港口联盟副主席、高级海事委员会成员和欧洲海港组织执行委员会成员。</p>
        <p>Anne Herv é ou：管理学资深老师，对多文化企业管理有独到的见解，精通西班牙语英语法语，曾有多个国家的任教经验。</p>
        <p>Slim Hadoussa：信息管理博士，信息管理及电子商务专业教授，Bank AI
          Bilad电子商务主席，曾在多个国家大学任教，现任职BBS全职教授。</p>
        <p>
          熊伟：对外经贸大学国际商学院营销学系主任，全球研究中心副主任，管理学博士，澳大利亚西悉尼大学和美国富布莱特基金密苏里大学高级访问学者，营销学副教授。长期担任中国经营报和香港企业管理专业协会主办的“中国杰出品牌营销奖”的策划和评审。</p>
        <p>张晨宇：北京理工大学，副教授，博士，硕士研究生导师，美国马凯特大学（Marquette
          University）商学院高级访问学者，从事创业投资、大学捐赠基金等方面的研究。</p>
        <p>王真：北京工商大学商学院，教授，MBA中心执行主任，美国马里兰大学、瑞典哥德堡大学访问学者。</p>
        <p>何辉：北京工商大学商学院人力资源管理系主任，副教授，管理学博士。</p>
        <p>
          张路：北京工商大学商学院会计系，博士，硕士生导师。MPAcc中心执行主任，财政部全国会计领军（后备）人才，注册会计师（CPA）非执业会员，美国注册金融分析师（CFA）。</p>
        <p>刘承元：哈工大本科毕业，国家公派留学日本大阪大学，获硕士博士学位。曾任世界500强理光深圳/上海公司高管。精益造物育人机制理论创始人、清华大学外聘教
          授、中国管理科学学会企管专委会首席专家。荣登《世界经理人》《企业管理》 和《企业家》杂志封面。</p>
        <p>党新民：世界500强理光深圳公司历练10年，从事精益咨询工作近20余年，擅长企业精益运营、精益生产、精益成本与精益品质等专业领域，成功辅导数百家企业，成
          效显著，广受好评。编撰出版了国内第一本精益JIT书籍，影响一大批制造业管理者。</p>
        <p>
          贾克勤：山东凯信重机公司董事长，用20余年时间成功打造了一家具有技术和管理优势的优秀企业，其成套造纸装备技术精湛，并反向出口到欧美市场，广受好评。从2010年开始，他带领团队学习和实践精益管理，取得了丰硕成果，积累了丰富经验。</p>
        <p>
          李政：中粮集团家佳康公司总经理助理，曾任中粮江阴公司董事长，长期从事集团企业运营管理，有丰富实战经验。自2012年开始，带领团队学习和实践精益，在集团内树立了多家管理标杆企业。在企业运营和精益管理方面，思想前卫，方法有效。</p>
        <p>
          广东威法家居总裁，长期从事企业运营管理，有丰富实战经验。自2016年开始，带领团队学习和实践精益管理，推动数字化转型，成果显著，把威法打造成广东省智能工厂示范企业。他在战略管理和智能工厂建设方面，经验丰富，有独到见解。</p>
        <p>
          李佩捷：先后在德国西门子欧司朗和日本东芝公司从事新产品设计开发及研发管理岗位10余年。在研发战略、新产品规划、研发项目管理、研发流程管理、需求管理、研发团队的能力提升、研发评审管理等研发领域有丰富的实战及咨询辅导经验。</p>
        <p>
          魏昊辉：富士康、爱普生企业管理岗位近十年的工作经验，多年从事工厂管理、精益生产推进工作，主导推进效率化活动。从事精益管理咨询工作10余年，在效率提升、低昂单交付管理、质量改善等领域有丰富经验，成功辅导数十家企业。</p>
        <p>
          张华：曾就职于美的、富士康等世界500强企业，在工厂和管理岗位十余年，擅长生产制造的流程运作、供应链体系搭建、精益生产推行等。从事精益管理咨询十余年，在工艺布局、物流改善、精益自动化以及精益減员增效等方面经验丰富。</p>
        <p>
          吴勇斌：曾于世界500强及中国500强等企业工作16年，曾任生产主管、质量主管、精益部长等职务。从事精益管理咨询八年，在精益TPM、精益TQM、质量信息化和精益现场管理等方面经验丰富。辅导企业精益管理数十家，效果显著。</p>
      </div>
      <!-- 部分师资 -->
      <!-- 入学流程 -->
      <div class="cont-item">
        <div class="title-image">入学流程</div>
        <img src="../assets/images/personRain/mba-lean-flow.png" alt="" class="flow-img"/>
        <!--申请条件-->
        <div class="title-image">申请条件</div>
        <p>本科或同等学历</p>
        <p>专科毕业，拥有3年及以上工作经验</p>
        <!--申请条件-->
        <!--申请材料-->
        <div class="title-image">申请材料</div>
        <div class="apply-item">
          <p class="apply-text">1.中英文申请表</p>
          <p class="apply-text">2.中英文简历</p>
          <p class="apply-text">3.中英文动机信</p>
          <p class="apply-text">4.毕业证复印件及英文翻译件或学信网认证报告及翻译件</p>
          <p class="apply-text">5.身份证原件照片复印件及英文翻译件</p>
          <p class="apply-text">6.白底两寸照片电子版</p>
          <p class="apply-text">7.中文推荐信1封</p>
        </div>
        <!--申请材料-->
      </div>
      <!-- 入学流程 -->
      <!-- 相关资料下载 -->
      <!--      <div class="down-load">-->
      <!--        <p>相关资料下载</p>-->
      <!--        <p class="open-pdf" @click="openPdf" >工商管理硕士(精益管理方向)</p>-->
      <!--      </div>-->
      <!--      <div style="clear: both"/>-->
      <!-- 相关资料下载 -->
    </div>
    <!-- 内容 -->
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->
  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: 'MbaVue',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {
    // openPdf() {
    //   window.open('http://cdn.yzvet.com/group1/M00/3F/9D/wKgCEmfBeT6AG8fhAR5sFnzvLOU119.pdf', '_blank');
    // }
  }
};
</script>

<style scoped lang="less">
.cont-page {
  background: #fff;
  height: auto;

  .banner-info {
    width: 100%;
    height: 200px;
    background: url(../assets/images/banner002.png);
    background-size: 100% 100%;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding-bottom: 80px;

    .cont-item {
      .title-image {
        background: url("../assets/images/pic1.png") no-repeat;
        width: 200px;
        height: 56px;
        line-height: 56px;
        background-size: 100% 100%;
        font-size: 24px;
        font-weight: 700;
        padding-left: 60px;
        color: #323232;
        margin: 40px 0;
      }

      p {
        font-size: 24px;
        color: #333;
        line-height: 38px;
      }

      .selector-indent {
        text-indent: 40px;
        font-size: 24px;
        font-weight: 400;
        color: #333;
        line-height: 38px;
      }

      //项目优势
      .advantage {
        .advantage-title {
          font-weight: bold;

          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background: #e58111;
            border-radius: 10%;
            margin-right: 8px;
          }
        }

        p {
          font-size: 24px;
          color: #333;
          vertical-align: middle;
        }
      }

      // 图片
      .course-img {
        max-width: 100%;
      }

      // 入学流程
      .flow-img {
        width: 100%;
      }

      // 申请资料
      .apply-item {
        background: #e58111;
        border-radius: 5px;
        margin-top: 20px;
        padding: 20px;

        .apply-text {
          color: #fff;
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    // 相关资料下载
    .down-load {
      float: right;
      font-size: 24px;
      margin-top: 50px;
      color: #333;
      text-align: right;

      .open-pdf {
        margin-top: 10px;
        font-size: 24px;
        color: #e58111;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/eduMbaLean.vue